import React from 'react';
import {Checkbox, FormControl} from '@deere/fuel-react';
import {Controller} from "react-hook-form";
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import {toDisplayName} from "../shared/utils";
import { getOptionSelectedByField } from "../shared/utils/autocompleteUtils";

const icon = <CheckBoxOutlineBlankIcon fontSize="small"/>;
const checkedIcon = <CheckBoxIcon fontSize="small"/>;

// AI-GENERATED: Helper function for conditional getOptionSelected
const getConditionalOptionSelected = (type) => {
    return type === 'sName' 
        ? getOptionSelectedByField('racfID')
        : getOptionSelectedByField('id');
};

export default function SummarySelectDropdown({
                                                  name,
                                                  options,
                                                  autocompleteValues,
                                                  label,
                                                  noShowTag,
                                                  onOptionsChange,
                                                  control,
                                                  type
                                              }) {
    return (
        <FormControl fullWidth style={{backgroundColor: '#fff'}}>
            <Controller
                control={control}
                defaultValue=""
                name={name}
                render={({onChange, value}) => (
                    <>
                        {noShowTag ? (
                            <Autocomplete
                                multiple
                                size="small"
                                id={name}
                                options={options}
                                defaultValue={autocompleteValues}
                                value={autocompleteValues}
                                disableCloseOnSelect
                                getOptionLabel={(option) => type === 'sName' ? `${toDisplayName(option.firstName, option.lastName)}` : option.description}
                                getOptionSelected={getConditionalOptionSelected(type)}
                                onChange={(e, value) => {
                                    onChange(value);
                                    onOptionsChange(value, type);
                                }}
                                renderOption={(option, {selected}) => (
                                    <React.Fragment>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{marginRight: 8}}
                                            checked={selected}
                                        />
                                        {type === 'sName' ? `${toDisplayName(option.firstName, option.lastName)}` : option.description}
                                    </React.Fragment>
                                )}
                                renderTags={() => null}
                                renderInput={(params) => (
                                    <TextField {...params} variant="outlined" placeholder={`${label}`}/>
                                )}
                            />
                        ) : (
                            <Autocomplete
                                multiple
                                size="small"
                                id={name}
                                options={options}
                                defaultValue={autocompleteValues}
                                value={autocompleteValues}
                                disableCloseOnSelect
                                getOptionLabel={(option) => type === 'sName' ? `${toDisplayName(option.firstName, option.lastName)}` : option.description}
                                getOptionSelected={getConditionalOptionSelected(type)}
                                onChange={(e, value) => {
                                    onChange(value);
                                    onOptionsChange(value, type);
                                }}
                                renderOption={(option, {selected}) => (
                                    <React.Fragment>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{marginRight: 8}}
                                            checked={selected}
                                        />
                                        {type === 'sName' ? `${toDisplayName(option.firstName, option.lastName)}` : option.description}
                                    </React.Fragment>
                                )}
                                limitTags={1}
                                renderInput={(params) => (
                                    <TextField {...params} variant="outlined"/>
                                )}
                            />
                        )}
                    </>
                )}
            />
        </FormControl>
    );
}